import {useState, useEffect, ReactNode, useRef} from 'react';
import {useIntl} from 'react-intl';
import sdk from '@/sdk';
import GuideBase, {IGuideBaseRef} from './GuideBaseTag';

interface IGuideProps {
    children: ReactNode;
    target: HTMLElement;
    isTarget: boolean;
    getIsRead: () => boolean;
}
export default function TagRecommendGuide(props: IGuideProps) {
    const intl = useIntl();
    const guideBaseRef = useRef<IGuideBaseRef>(null);
    const {target, getIsRead, isTarget} = props;

    const [visible, setVisible] = useState(false);

    function closeGuide() {
        setVisible(false);
        sdk.as
            .updateNewGuide({
                tagRecommendIsRead: true,
            })
            .catch(err => console.error(err));
    }

    useEffect(() => {

        function close() {
            closeGuide();
        }

        function onDocmentClick(e: Event) {
            if (guideBaseRef.current) {
                const popperWrapEl = guideBaseRef.current.getPopperWrapEl();
                if (popperWrapEl?.contains(e.target as Element)) {
                    return;
                }
            }
            close();
        }
        if (!getIsRead() && isTarget && !visible) {
            document.addEventListener('click', onDocmentClick);
            setVisible(true);
        }

        return () => {
            if (target && !getIsRead()) {
                document.removeEventListener('click', onDocmentClick);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTarget, getIsRead]);

    return (
        <GuideBase
            ref={guideBaseRef}
            visible={visible}
            target={target}
            onClose={closeGuide}
            content={intl.formatMessage({id: 'tagRecommendDesc'})}
            width={185}
        >
            {props.children}
        </GuideBase>
    );
}
